import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
  ButtonModule,
  FlexboxModule,
  PaddingModule,
  SearchModule,
  SimpleModalModule,
  SpacingModule,
  TitleModule,
} from '@frk/eds-components';
import { TranslateModule } from '@shared/translate/translate.module';
import { AddToWatchlistModalComponent } from './add-to-watchlist-modal.component';

@NgModule({
  declarations: [AddToWatchlistModalComponent],
  exports: [AddToWatchlistModalComponent],
  imports: [
    ButtonModule,
    CommonModule,
    FlexboxModule,
    PaddingModule,
    SearchModule,
    SimpleModalModule,
    SpacingModule,
    TitleModule,
    TranslateModule,
  ],
})
export class AddToWatchlistModalModule {}
